﻿import React, { useEffect, Fragment } from 'react';
import ReactDOM from 'react-dom';

import controller from '../../../../Resources/Scripts/_Shared/controller';

import { shouldAccountBeUpdated } from '../../../../Resources/Scripts/_Shared/helpers';
import { Divider } from '../../../../Resources/Scripts/_Shared/elements/Divider';
import CreateAccount from '../../BookingFlowPage/Scripts/steps/CreateAccount';
import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history'

const formLogin = (context) => {
  const lang = document.querySelector('html').getAttribute('lang');
  const appConfig = controller.getConfig(context);
  const appContainer = context;
  let urlParams = new URLSearchParams(window.location.search);
  urlParams = urlParams.toString().length > 0 ? '?' + urlParams.toString() : '';
  const App = () => {
    const loginHandler = () => {
      window.location.href = appConfig.episerver.loginUrl + encodeURIComponent(urlParams);
    };

    useEffect(() => {
      const loggedIn = appConfig.episerver.loggedIn;
      const activeProfile = !!appConfig.episerver.activeProfile;
      const hasMoreThanOneProfile = appConfig.episerver.hasMoreThanOneProfile;
      const switchAccountUrl = appConfig.episerver.switchAccountUrl;
      let urlParams = new URLSearchParams(window.location.search);
      urlParams = urlParams.toString().length > 0 ? '?' + urlParams.toString(): '?';
      const shouldUpdateAccount = appConfig.episerver.shouldUpdateAccount;
      //const loginType = urlParams.get('L') ?? urlParams.get('l');

      //if ((!loggedIn || !loginType) && !hasMoreThanOneProfile) {
      //  return;
      //}
      if (!loggedIn && !hasMoreThanOneProfile) return;

      if (loggedIn && (hasMoreThanOneProfile && !activeProfile)) {
        window.location.href = switchAccountUrl + encodeURIComponent(urlParams);
        return;
      }

      if (!appConfig.episerver.hasWebticketAccount || shouldAccountBeUpdated(appConfig) || !activeProfile) {
        ReactDOM.render(<CreateAccount editSettings={false} formLogin={true} bookingFlowContext={appConfig} formData={appConfig} />, context);
      }
      //else if (loginType === 'gst') {
      //    setBookingFlowContext({ ...bookingFlowContext, activeStep: bookingFlowappConfig.availableSteps.createAccount.index, guest: true })
      //}

      //}, [bookingFlowappConfig.episerver.activeProfile])
    }, [appConfig.episerver.loggedIn])

    //useEffect(() => setBookingflowStep(bookingFlowappConfig.availableSteps.login.index), [])
    const activeProfile = appConfig.episerver.activeProfile || false;

    //if (appConfig.loggedIn && (bookingFlowappConfig.episerver.hasMoreThanOneProfile && !activeProfile)) {
    if (appConfig.episerver.loggedIn) {
      return (
        <div className="bookingflowpage__loader">
          <div className="aimo-spinner"><span></span><span></span><span></span><span></span></div>
        </div>
      )
    }

    return (
      <div className="bookingflowpage__app bookingflowpage__app--login">
        <button className="bookingflowpage__back bookingflowpage__back--login" onClick={() => { history.go(-1); }}>{appConfig.localization.buttons.previousStep}</button>
        <div className="single-step single-step--login">
          <h2>{appConfig.localization.heading}</h2>
          {appConfig.loginPreamble && <p className="margin center">{appConfig.loginPreamble}</p>}
          <button className="single-step__button single-step__button--proceed" onClick={loginHandler}>{appConfig.localization.buttons.loginOrCreate}</button>
          {/*{bookingFlowappConfig.episerver.productType === 2 && <Fragment>*/}
          {/*  <Divider />*/}
          {/*  <h3 className="nomargin">{appConfig.localization.guest.heading}</h3>*/}
          {/*  <p className="margin center">{appConfig.localization.guest.text}</p>*/}
          {/*  <button className="single-step__button single-step__button--blue single-step__button--createguestaccount" onClick={createGuestAccountHandler}>{appConfig.localization.buttons.guestAccount}</button>*/}
          {/*</Fragment>}*/}
        </div>
      </div>
    )
  }

  function init() {
    ReactDOM.render(<App />, appContainer);
  }

  return {
    init
  };
}

controller.add('form-page-login', formLogin);